import { Badge, BadgeType } from '@appliedsystems/applied-design-system';
import { PolicyDetails } from '@appliedsystems/payments-core';
import React from 'react';
import { currencyMap } from '../../../constants/constants';
import { usePaymentsTranslation } from '../../../hooks/usePaymentsTranslation';
import { Locale } from '../../../store/Locale';
import { toIntlFormatHelper } from '../../../util/getAmountWithFees';
import classes from '../../SummaryCard/SummaryCard.module.scss';

type PolicySummaryProps = {
  policy: PolicyDetails;
  showPill: boolean;
  badgeType: BadgeType;
  badgeText: string;
  badgeIcon?: string | undefined;
  badgeTestId: string | undefined;
};

export const PolicySummary = ({
  policy,
  showPill,
  badgeType,
  badgeText,
  badgeIcon,
  badgeTestId,
}: PolicySummaryProps) => {
  const { t } = usePaymentsTranslation();
  const { locale } = Locale.useContainer();
  const paymentAmount =
    (policy.estimatedPremium ?? 0) +
    (policy.fullyEarnedFees ?? 0) +
    (policy.financedFees ?? 0) +
    (policy.financedTaxes ?? 0);
  const formattedAmount = toIntlFormatHelper(paymentAmount, currencyMap[locale], locale) || '-';

  return (
    <div key={policy.policyNumber}>
      <div className={classes.invoice}>
        <span className={classes.invoiceTitle}>
          {t('POLICY')} {policy.policyNumber}{' '}
          {showPill && (
            <Badge type={badgeType} size="xxs" icon={badgeIcon} testId={badgeTestId}>
              {badgeText}
            </Badge>
          )}
        </span>
      </div>
      <div className={classes.invoiceItem}>
        <div>
          {policy.policyDescription?.map((desc, index) => (
            <div key={index}>{desc}</div>
          ))}
        </div>
        <div>{formattedAmount}</div>
      </div>
    </div>
  );
};
